<template>
    <main :class="displayClass + ' pt-4'">
        <div class=" mb-5">
            <h3 class="text-center my-3">OtherReservation</h3>
            <div class=" pb-3">
                <div class="row mb-3">
                    <div class="col">
                    <p class="alert alert-info">
                        その他施設ご利用のご予約はお問合せ下さい。
                    </p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<style>
.head_rsv {
    font-size: 90% !important;
    font-weight: bold !important;
    background: #9EC5FE;
}
</style>
<script>
// import otherReservationList from '../Other/ListReservationView.vue'

export default {
    name: 'BsDashBoardView',
    data: function () {
        return {
            'tab_active': 'drive',//or th ead
        }
    },
    props: {
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
    },
    components: {
        // otherReservationList,
    },
    methods: {
        tab_switch_action(tab) {
        this.tab_active = tab;
        },
    },
    computed: {
        tabDisplay: function () {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'd-none ';
            if(self_tab_active == tab){
            tabClass = 'd-block';
            }
            return tabClass;
        }

        },
        tab_switch: function() {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'nav-link ';
            console.log('tab_switch', self_tab_active);
            if(self_tab_active == tab){
            tabClass += 'active';
            }
            return tabClass;
        }
        },
    }
}
</script>
